
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import FolderStructure from './FolderStructure'
import { alphabetiseFolders } from '../utils/alphabetiseFolders'

type Props = {
    folders: ObjectStringKeyAnyValue
    setSelectedFolderId: React.Dispatch<React.SetStateAction<any>>,
    selectedFolderId: string | null
    itemToMove?: ObjectStringKeyAnyValue
    showTopLevel: boolean

}


function SelectRecursiveFolder({
    folders,
    setSelectedFolderId,
    selectedFolderId,
    itemToMove,
    showTopLevel = false
}: Props) {


    const alphabetisedArray = alphabetiseFolders(folders)


    return <div className={`w-full flex flex-col gap-1`}>

        {showTopLevel && <div
            className={`
                    ${!selectedFolderId ? 'bg-brandblue text-white' : 'bg-gray-100 border-gray-400'}
                    rounded px-2 py-1 border border-1 cursor-pointer hover:opacity-80`}

            onClick={() => { setSelectedFolderId('') }}
        >Top level</div>}


        {alphabetisedArray.map((thisItemId: string, index: number) => {
            const thisItem = folders[thisItemId]
            if (itemToMove && itemToMove.thisItemId === thisItemId) return null
            if (!thisItem.DisplayName) return null
            return <div key={index} className={`w-full flex flex-col gap-1 pl-4`}>
                <div key={index}
                    className={`
                    ${selectedFolderId === thisItemId ? 'bg-brandblue text-white' : 'bg-gray-100 border-gray-400'}
                    rounded px-2 py-1 border border-1 cursor-pointer hover:opacity-80`}
                    onClick={() => { setSelectedFolderId(thisItemId) }}
                >
                    {thisItem.DisplayName}
                </div>
                {thisItem.Subfolders && <SelectRecursiveFolder
                    selectedFolderId={selectedFolderId}
                    setSelectedFolderId={setSelectedFolderId}
                    folders={thisItem.Subfolders}
                    itemToMove={itemToMove}
                    showTopLevel={false}
                    
                />}
            </div>
        })}
    </div>
}

export default SelectRecursiveFolder